import React, { useState } from 'react';
import { NotificationManager } from "react-notifications";
import resetPasswordOtpResponse from '../../apis/password/resetPasswordOtp';
import validateEmail from '../../utilities/validateEmail';
import '../resetpassword/resetpassword.css';

const ForgotPasswordForm = ({ onOtpSent, onBackToSignIn }) => {
  const [email, setEmail] = useState('');
  const [emailTouched, setEmailTouched] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const isEmailValid = validateEmail(email) && email.length > 0;

  const handleEmailChange = (value) => {
    setEmail(value);
    setEmailTouched(true);
  };

  const handleSendOtp = async () => {
    const payloadData = { email };
    setIsLoading(true);
    
    try {
      const resetpassworotpData = await resetPasswordOtpResponse(payloadData);
      
      if (resetpassworotpData.data.message.includes('We do not have an account in ClearedTalent')) {
        NotificationManager.error("We do not have an account in ClearedTalent with this email address", "Error", 10000);
        return;
      }
      
      NotificationManager.success("OTP Sent", "Success", 10000);
      
      if (onOtpSent) {
        onOtpSent(email);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login_wrapper_main">
      <div className='login_container login-box-border reset-password-modern'>
        <div className='candidate-signin-title'>
          <p className='fs-semi-bold fs-22'>Reset your password</p>
          <p className='reset-subtitle'>Enter your email address to receive an OTP</p>
        </div>
        
        <div className='reset-password-content'>
          <div className='form-group-reset'>
            <label className="field_name_reset" htmlFor="email">
              Email Address
            </label>
            
            <input
              type="text"
              id="email"
              name="fpEmail"
              className="password-input-reset"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => handleEmailChange(e.target.value)}
              required
            />
            
            {emailTouched && !isEmailValid && (
              <p className='form-error-reset'>
                Please enter a valid email address
              </p>
            )}
          </div>
          
          <div className="clear_login_remember_sec mt-10">
            <label className="fgtext cp" onClick={onBackToSignIn}>
              Back to Sign-In
            </label>
          </div>

          <div className='reset-password-btn-container'>
            <button
              type="button"
              className='btn-reset-password-modern'
              onClick={handleSendOtp}
              disabled={!isEmailValid || isLoading}
            >
              {isLoading ? 'Sending...' : 'Send OTP'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordForm;
